import { fixNaN } from './fixNaN'

export const realToCents = (real) => {
  return fixNaN(real * 100)
}
